<template>
  <b-container>
    <b-row>
      <b-col class="text-center mt-5">
        <b-avatar v-if="hasImage" class="mb-4 p-2" :src="item.thumbnail" size="5rem" />
        <h2 class="title">
          <nuxt-link :to="$trailingSlash(localePath(type))"> {{ name }}</nuxt-link>
          <span>&nbsp;/ {{ item.name }}</span>
        </h2>
        <h1>{{ item.title }}</h1>
        <h2 class="description mb-4">
          {{ item.description }}
        </h2>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: function () {
        return {
          thumbnail: 'https://cdn.vexels.com/img/header-icon.svg',
          name: 'Vexels',
          description:
            'We create beautiful illustrations & exclusive designs like vector images, icons ...'
        };
      }
    },
    name: {
      type: String,
      required: true,
      default: ''
    },
    type: {
      type: String,
      required: true,
      default: ''
    },
    hasImage: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  margin-bottom: 15px;
  span {
    font-size: 18px;
  }
  a {
    font-size: 18px;
    color: #000;
  }
}
.description {
  font-size: 16px;
  font-weight: 400;
  color: #212529;
}
p {
  font-size: 16px;
}
.badge-secondary {
  background: #b8aea4;
}
</style>
